module.exports = __webpack_public_path__ + "img/table.d908d04e.jpg";